import { TailwindColorOrString, tailwindColors } from '@repo/tailwind-config/tailwind.vars'

import { StatusOption } from '../../utils'

export enum MissionReportStatusEnum {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  VALIDATED = 'VALIDATED'
}

export const missionReportStatusEnumMapping: Record<
  MissionReportStatusEnum,
  StatusOption & {
    color?: TailwindColorOrString
  }
> = {
  [MissionReportStatusEnum.DRAFT]: {
    label: 'Brouillon',
    variant: 'danger',
    color: tailwindColors.red.DEFAULT
  },
  [MissionReportStatusEnum.SENT]: {
    label: 'Envoyé',
    variant: 'warning',
    color: tailwindColors.orange.DEFAULT
  },
  [MissionReportStatusEnum.VALIDATED]: {
    label: 'Validé',
    variant: 'success',
    color: tailwindColors.green.DEFAULT
  }
}
